import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Smartphone, Laptop, Watch, Monitor, Globe, ArrowRight } from 'lucide-react';

const WHATSAPP_NUMBER = "5521980277322";

const services = [
  {
    icon: Smartphone,
    title: "Reparo de Celular",
    description: "Conserto de iPhone, Samsung, Xiaomi, Motorola. Troca de tela, bateria, conector de carga e muito mais.",
    link: "/celular",
    keywords: ["iPhone", "Samsung", "Xiaomi", "Motorola"],
    whatsappMsg: "Olá! Preciso de assistência técnica para meu celular."
  },
  {
    icon: Laptop,
    title: "Reparo de Notebook",
    description: "Manutenção completa de notebooks. Troca de HD/SSD, upgrade de memória, formatação e limpeza.",
    link: "/notebook",
    keywords: ["Dell", "HP", "Lenovo", "Acer"],
    whatsappMsg: "Olá! Preciso de assistência técnica para meu notebook."
  },
  {
    icon: Watch,
    title: "Reparo de Smartwatch",
    description: "Especialistas em Apple Watch e relógios Garmin. Troca de tela, bateria e restauração completa.",
    link: "/smartwatch",
    keywords: ["Apple Watch", "Garmin", "Samsung Galaxy Watch"],
    whatsappMsg: "Olá! Preciso de assistência técnica para meu smartwatch."
  },
  {
    icon: Monitor,
    title: "Reparo de Computador",
    description: "Assistência técnica de PC. Formatação, remoção de vírus, upgrade e manutenção preventiva.",
    link: "/computador",
    keywords: ["Desktop", "PC Gamer", "All-in-One"],
    whatsappMsg: "Olá! Preciso de assistência técnica para meu computador."
  },
  {
    icon: Globe,
    title: "Criação de Sites",
    description: "Desenvolvimento de sites profissionais, landing pages e lojas virtuais para seu negócio.",
    link: "/webdesign",
    keywords: ["Landing Page", "E-commerce", "WordPress"],
    whatsappMsg: "Olá! Tenho interesse em criar um site para meu negócio."
  },
];

export const Services = () => {
  return (
    <section id="servicos" className="section-darker py-24 md:py-32 grid-bg" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-[#00F0FF] text-sm font-mono uppercase tracking-widest">
            [ Nossos Serviços ]
          </span>
          <h2 className="font-orbitron text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
            Soluções Completas em <span className="text-[#00F0FF]">Tecnologia</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto font-space">
            Oferecemos serviços especializados para todos os seus dispositivos eletrônicos com garantia e qualidade.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="cyber-card p-8 group corner-brackets"
              data-testid={`service-card-${index}`}
            >
              {/* Icon */}
              <div className="service-icon mb-6">
                <service.icon size={28} />
              </div>

              {/* Title */}
              <h3 className="font-rajdhani text-xl font-bold text-white mb-3 group-hover:text-[#00F0FF] transition-colors">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-[#94A3B8] font-space text-sm leading-relaxed mb-4">
                {service.description}
              </p>

              {/* Keywords */}
              <div className="flex flex-wrap gap-2 mb-6">
                {service.keywords.map((keyword, idx) => (
                  <span
                    key={idx}
                    className="text-xs font-mono text-[#00F0FF]/70 bg-[#00F0FF]/5 px-2 py-1 border border-[#00F0FF]/20"
                  >
                    {keyword}
                  </span>
                ))}
              </div>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to={service.link}
                  className="flex items-center justify-center gap-2 text-sm text-[#00F0FF] font-mono hover:underline"
                  data-testid={`service-link-${index}`}
                >
                  Saiba mais <ArrowRight size={14} />
                </Link>
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(service.whatsappMsg)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 text-sm text-[#25D366] font-mono hover:underline"
                  data-testid={`service-whatsapp-${index}`}
                >
                  WhatsApp
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
